class Reviews extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            direction: 'horizontal',
            slidesPerView: 'auto',
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector('.swiper-next'),
                prevEl: this.querySelector('.swiper-prev'),
            },
        });
    }
}

customElements.define('review-slider', Reviews);